import BaseMixin from '@/views/mixin.vue'
import compBaseedit from './baseformedit.vue'
import compSearch from './search'
import '@/style/product-icon.scss'

import { mapState, mapGetters } from "vuex";
import {
    HttpGetProductsList,
    HttpCancelIcons,
    HttpAddIcons,


} from '@/service/products/allproducts'
import compImport from '../compimport'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

import compIndex from './update'
import compInventory from './inventory'
import compEditfob from './editfob'

export default {
    mixins: [BaseMixin],
    components: {
        compUpload: () => import("@components/templates/upload"),
        compSearch,
        compImport,
        compIndex,
        compInventory,
        compEditfob,
        compBaseedit
    },
    created () {
        this.productCancel = this.handleAuth('erp.product.cancel');
        this.productSet = this.handleAuth('erp.product.set');
    },
    mounted () {
        if (this.keyword) {
            this.$refs.compsearch.isOpen = true
        }
        this.$refs.compsearch.formData.EQ_keyword = this.keyword
        this.updateSearch({ search: this.$refs.compsearch.formData, page: 1 })
    },
    data () {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            fudingdan: 0,
            keyword: this.$route.query.keyword,
            isFragile: '/static/picture/chaizi.png',
        };
    },
    methods: {
        httpList: HttpGetProductsList,
        handleOperates (data, type, iconid) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeids: data,
                        querytype: 'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'allproductsUpdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'allproductsUpdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'add': {
                    this.$router.push({
                        name: 'allproductsUpdate',
                        params: { type: 'add' },
                    });
                    break;
                }
                case 'disabled': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: this.$tc("global.common.inactive", 2, { defaultValue: '停用' }),
                            desc: this.$t("erp.product.disabled_desc", { defaultValue: '停用后将无法再为该SKU制作采购单、销售订单等，请确认？' }),
                            type,
                            id: data,
                        }
                    }
                    break;
                }

                case 'actived': {
                    this.showDel = true;
                    this.operate = {
                        title: this.$tc("global.common.active", 3, { defaultValue: '激活' }),
                        desc: this.$t("erp.product.active_desc", { defaultValue: '确定激活操作？' }),
                        id: data,
                        type,
                    }
                    break;
                }
                case 'addcoloricon': {
                    // 添加标签
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        // console.log(iconid)
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.product.add_label', { defaultValue: '增加标签' }),
                            desc: this.$t('erp.product.addlabel_desc', { defaultValue: '确定增加该标签？' }),
                            id: data,
                            type,
                            typeid: iconid
                        }
                    }
                    break;
                }
                case 'deletecoloricon': {
                    // 添加标签
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        // console.log(iconid)
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.product.delete_label', { defaultValue: '删除标签' }),
                            desc: this.$t('erp.product.deletelabel_desc', { defaultValue: '确定删除该标签？' }),
                            id: data,
                            type,
                            typeid: iconid
                        }
                    }
                    break;
                }
                case 'importBase':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_base', { defaultValue: '导入基本信息' }),
                        width: 460,
                        showFooter: false,
                        erpskutitle: this.$t('erp.product.importbase_title', { defaultValue: '直接更新：项目以外的其他数据直接更新' }),
                        component: "compImport",
                        importType: 1,
                        comptitle: this.$t('erp.product.importbase_comptitle', { defaultValue: '已存在ERPSKU' }),
                        actionurl: "/api/v1/Product/import",
                        downrul: '/api/v1/Product/excel',
                        showtype: 7,
                    }
                    break
                case 'importWarehouse':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_warehouse', { defaultValue: '导入仓库发货信息' }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        name: "excelFile",
                        component: "compUpload",
                        data: { contextId: global.SYSID, importType: 2, isUpdate: 0 },
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 2 }, 'download')
                        },

                    };
                    break
                case 'importHead':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_head', { defaultValue: '导入头程信息' }),
                        width: 460,
                        showFooter: false,
                        data: { contextId: global.SYSID, importType: 3, isUpdate: 0 },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 3 }, 'download')
                        },
                    };
                    break
                case 'importBuy':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_buy', { defaultValue: '导入采购信息' }),
                        showDesc: false,
                        component: "compUpload",
                        data: { importType: 4, isUpdate: 0 },
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 4 }, 'download')
                        },
                    };
                    break
                case 'importClear':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_qingguan', { defaultValue: '导入清关信息' }),
                        showDesc: false,
                        component: "compUpload",
                        data: { importType: 5, isUpdate: 0 },
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 5 }, 'download')
                        },
                    };
                    break
                case 'importAll':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_other', { defaultValue: '导入其他信息' }),
                        showDesc: false,
                        component: "compUpload",
                        data: { importType: 8, isUpdate: 0 },
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 8 }, 'download')
                        },
                    };
                    break
                case 'importFob':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_fob', { defaultValue: '导入Fob信息' }),
                        showDesc: false,
                        component: "compUpload",
                        data: { importType: 7, isUpdate: 0 },
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/Product/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/excel', { importType: 7 }, 'download')
                        },
                    };
                    break
                case 'importStorage':
                    this.operate = {
                        show: true,
                        title: '仓储客户导入专用',
                        width: 460,
                        showFooter: false,
                        component: "compImport",
                        importType: 9,
                        comptitle: '导入类型',
                        erpskutitle: '注意：更新时，项目、FOB不更新；FOB请在页面单个更新或通过多币种导入更新',
                        actionurl: "/api/v1/Product/import",
                        downrul: '/api/v1/Product/excel',
                        cangchuType: [
                            { value: 0, label: '新增' },
                            { value: 1, label: this.$t('fbb.alloment.update', { defaultValue: '更新' }) }
                        ],
                        showtype: 2,

                    }
                    break
                case 'inventory':
                    this.operate = {
                        title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compInventory",
                        comperpsku: data,
                        querytype: 'query'
                    }
                    // window.open(process.env.VUE_APP_FBB+'/home/inventory/list?erpsku='+data, '_blank');
                    break
                case 'editfob':
                    this.operate = {
                        title: this.$t("erp.product.edit_fob", { defaultValue: '编辑FOB' }),
                        show: true,
                        width: 600,
                        component: "compEditfob",
                        activeid: data,
                        querytype: 'query'
                    }
                    break
                case 'pushwarehouse': {
                    // 推送仓库
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.operate = {
                            title: this.$t('erp.b2c.pushyuncang', { defaultValue: '推送仓库' }),
                            width: 460,
                            show: true,
                            params: this.checkedId,
                            component: 'compBaseedit',
                            typeform: 'pushyuncang'
                        }
                    }
                    break;
                }
                case 'replenishment': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.operate = {
                            title: this.$t('erp.product.batch_replenishment', { defaultValue: '批量修改补货状态' }),
                            width: 460,
                            show: true,
                            params: this.checkedId,
                            component: 'compBaseedit',
                            typeform: 'replenishment'
                        }
                    }
                    break;
                }
            }
        },

        async batchOpearte () {
            let request, { type, id, typeid } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            // console.log(typeid)
            switch (type) {
                case 'actived': request = HttpCancelOrder; params = { orderId: this.operate.id }; break;
                case 'disabled': request = HttpCancelIcons; params = { ids: this.checkedId.join(',') || id }; break;
                case 'addcoloricon': request = HttpAddIcons; params = { ids: this.checkedId.join(','), labelIds: typeid, type: 1 }; break;
                case 'deletecoloricon': request = HttpAddIcons; params = { ids: this.checkedId.join(','), labelIds: typeid, type: 0 }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
        // 操作下的列表展示内容
        getOperateNodeMap (row) {
            const { id, enable } = row
            return [{
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: enable === 1 && this.productSet,
                // to: {
                //     name: 'allproductsUpdate',
                //     params: { type: 'edit' },
                //     query: { id },
                // },
                params: id,
                operate: 'edit'
            }, {
                label: this.$t("erp.product.edit_fob", { defaultValue: '编辑FOB' }),
                show: enable === 1 && this.productSet,
                params: id,
                operate: 'editfob'
            }, {
                label: this.$tc('global.common.inactive', 2, { defaultValue: '停用' }),
                show: enable === 1 && this.productCancel,
                params: id,
                operate: 'disabled'
            }]
        },
    },
    computed: {
        ...mapState('boss', ['products', 'warehouseList']),
        ...mapGetters('diction', ['getNewDifferentAllProductList', 'getNewWarehouseIdList']),
        ...mapGetters('common', ['getProductsSizeList']),
        getChargeSizeType () {
            return [
                {
                    label: this.$t("erp.product.chargesizetype_0", { defaultValue: "常规品" }),
                    value: 0,
                    theme: "tag-deepgreen tagSize"
                },
                {
                    label: this.$t("erp.product.chargesizetype_1", { defaultValue: "超大异形品" }),
                    value: 1,
                    theme: "tag-purple tagSize"
                },
                {
                    label: this.$t("erp.product.chargesizetype_2", { defaultValue: "异形品" }),
                    value: 2,
                    theme: "tag-blue tagSize"
                }
            ];
        },
        columns () {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                width: 95,
                render: this.getOperateNodes,
            },
            {
                title: this.$t('global.common.base_information', { defaultValue: '基本信息' }),
                render: (h, { row }) => {
                    const id = row.lineId;
                    // const product = this.products.filter((item) => {
                    //     return id === item.id
                    // })[0] || {};
                    let isContainBattery = (
                        <div class="icon-padding isContainBattery" data-desc={this.$t('erp.product.include_battery', { defaultValue: '含电池' })}>
                            <Icon class="my-icon" type="md-battery-charging" />
                        </div>
                    )
                    let isMagnetism = (
                        <div class="icon-padding isMagnetism" data-desc={this.$t('erp.product.include_mangent', { defaultValue: "带磁" })}>
                            <Icon class="my-icon" type="ios-magnet" />
                        </div>
                    )
                    let isLiquid = (
                        <div class="icon-padding isLiquid" data-desc={this.$t('erp.product.include_liquid', { defaultValue: "含液体" })}>
                            <Icon class="my-icon" type="ios-water-outline" />
                        </div>
                    )
                    let shapeType = (
                        <div class="icon-padding shapeType" data-desc={this.$t('erp.product.differentform', { defaultValue: "异形体" })}>
                            <Icon class="my-icon" type="ios-bookmark" />
                        </div>
                    )
                    let isFragile = (
                        <div class="icon-padding isFragile" data-desc={this.$t('erp.product.fraglie', { defaultValue: "易碎" })}>
                            <Icon class="my-icon" type="ios-wine" />
                        </div>
                    )
                    return <div class="icon-main-container">
                        <div>
                            <div>
                                <span class="font-bold">SKU: </span>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpSku}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon
                                    class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div><span class="font-bold">{this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' })}: </span>{row.erpSkuCode || '--'}</div>
                            <div><span class="font-bold">{this.$t('erp.product.category', { defaultValue: '品类' })}: </span>{row.codeName || '--'}</div>
                            <div><span class="font-bold">{this.$t('global.common.name', { defaultValue: '名称' })}: </span>{row.name}</div>
                            <div><span class="font-bold">{this.$t('global.common.En_name', { defaultValue: '名称(英文)' })}: </span>{row.nameEn}</div>
                            <div><span class="font-bold">{this.$t('global.common.line', { defaultValue: '项目' })}</span>: {this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)}</div>
                            <div><span class="font-bold">{this.$t('erp.product.factory_code', { defaultValue: '工厂编码' })}: </span>{row.factoryCode || '--'}</div>
                            <div><span class="font-bold">FOB: </span>{row.fobPrice}</div>
                        </div>
                        <div class="icon-container">
                            {row.isContainBattery ? isContainBattery : ''}
                            {row.isMagnetism ? isMagnetism : ''}
                            {row.isLiquid ? isLiquid : ''}
                            {row.shapeType ? shapeType : ''}
                            {row.isFragile ? isFragile : ''}
                        </div>
                    </div>
                },
            },
                {
                    title: 'img',
                    width:150,
                    render: (h, { row }) => {
                        let image = row.imageUrl;
                        if (image) {
                            return <div>
                                <div style="float: left; cursor: pointer; margin-right: 10px;">
                                    <img style="width: 100px; height: 100px;" src={image}></img>
                                </div>
                            </div>;
                        } else {
                            return <div>
                                <div><span>-</span></div>
                            </div>;
                        }

                    },
                },
            {
                title: this.$t('erp.product.label', { defaultValue: '标签' }),
                width: 80,
                render: (h, { row }) => {

                    if (row.productLabel) {
                        let arr = row.productLabel.split(",")

                        let arr2 = arr.map(item => {
                            return this.$refs.compsearch.iconList.filter(json => json.value == item)
                        })
                        return arr2.map(obj => {
                            return <div class="text-center margin-bottom-5"><div class={obj[0].labelColour}>{obj[0].label}</div></div>
                        })
                    } else {
                        return <div>--</div>
                    }

                },

            },
            {
                title: this.$t('erp.product.productpurchase_status_1', { defaultValue: '产品状态/补货状态/销售定位' }),
                width: 150,
                render: (h, { row }) => {
                    var status;
                    switch (row.status) {
                        case 0: status = <span>{this.$t('erp.product.replenishment', { defaultValue: '正常补货' })}</span>; break;
                        case 1: status = <span>{this.$t('erp.product.no_replenishment', { defaultValue: '不再补货' })}</span>; break;
                    }
                    var enable;
                    switch (row.enable) {
                        case 1: enable = <span class="tag-deepgreen tagSize">{this.$tc('global.common.active', 2, { defaultValue: '可用' })}</span>; break;
                        case 0: enable = <span class="tag-red tagSize">{this.$tc('global.common.inactive', 2, { defaultValue: '停用' })}</span>; break;
                    }
                    var salesLocation;
                    switch (row.saleLocation) {
                        case 0: salesLocation = <span>{this.$t('erp.product.none', { defaultValue: '无' })}</span>; break;
                        case 1: salesLocation = <span>NEW</span>; break;
                        case 2: salesLocation = <span>Core</span>; break;
                        case 3: salesLocation = <span>Normal</span>; break;
                        case 4: salesLocation = <span>Normal</span>; break;
                        case 5: salesLocation = <span>Discontinued-w/ Inventory</span>; break;
                        case 6: salesLocation = <span>Discontinued-w/o Inventory</span>; break;
                    }
                    return <div>
                        <div>{enable}</div>
                        <div>{status}</div>
                        <div>{salesLocation}</div>
                    </div>;
                }
            },
            {
                title: this.$t('erp.product.total_inventory', { defaultValue: '总库存' }),
                width: 80,
                render: (h, { row }) => {
                    return <div>
                        <div><a onClick={this.handleOperates.bind(this, { erpsku: row.erpSku, qty: row.inventory }, 'inventory')}>{row.inventory == 0 ? row.inventory : row.inventory == null ? '--' : row.inventory}</a></div>
                    </div>
                },

            },
            {
                title: this.$t('erp.product.weight_volume', { defaultValue: '重量(lb)/体积(inch³)' }),
                width: 220,
                render: (h, { row }) => {

                    let sizeItem = this.getChargeSizeType.find(item => {
                        return item.value == row.chargeSizeType;
                    }) || {};
                    return <div>
                        <div>{(Number(row.weight) / 453.592).toFixed(4) || '--'}</div>
                        <div>{((Number(row.width) / 2.54) * (Number(row.height) / 2.54) * (Number(row.length) / 2.54)).toFixed(4) || '--'}</div>
                        <br />
                        <div><span class="font-bold">{this.$t("erp.setting.goods_size_1", { defaultValue: "FBA Size" })}:</span> <span class={this.getProductsSizeList[row.packingSizeType].color}>{this.getProductsSizeList[row.packingSizeType].label || '--'}</span></div>
                        <div class="margin-top-5"><span class="font-bold">Cope Size:</span> <span class={sizeItem.theme || ""}>{sizeItem.label || "--"}</span></div>
                    </div>

                },
            },
            {
                title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                width: 100,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.updatedAt || '-'}</div>
                    </div>

                },
            },

            ];
            return datalist;
        },
    },
};




